import angular from "angular";
import Vue from "vue";
import "ngVue";
import CourseImportWizard from "./CourseImportWizard.vue";
import CourseColumnMapper from "./CourseColumnMapper.vue";
import CourseFileUploader from "./CourseFileUploader.vue";
import CourseImportPreview from "./CourseImportPreview.vue";
import CourseImportResults from "./CourseImportResults.vue";
import CourseMappingLoadModal from "./CourseMappingLoadModal.vue";
import CourseMappingSaveModal from "./CourseMappingSaveModal.vue";
import CourseValueMapper from "./CourseValueMapper.vue";

export {
  CourseImportWizard,
  CourseColumnMapper,
  CourseFileUploader,
  CourseImportPreview,
  CourseImportResults,
  CourseMappingLoadModal,
  CourseMappingSaveModal,
  CourseValueMapper,
};

export default angular
  .module("admin.directives.courseimport", [])
  .directive("dcCourseImportWizard", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcCourseImportWizard", CourseImportWizard));
    },
  ]);
